<template>
  <div class="np-sound-picker">
    <label v-if="label" class="np-sound-picker__label">{{ label }}</label>
    <div class="np-sound-picker__row">
      <select class="form-control np-sound-picker__select" :value="value" @change="onChange">
        <option v-for="s in sounds" :key="s.filename" :value="s.filename">{{ s.label }}</option>
      </select>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary np-sound-picker__preview"
        :title="'Preview ' + currentLabel"
        @click="preview"
      >
        <i class="fa fa-play"></i>
      </button>
    </div>
    <small v-if="hint" class="np-sound-picker__hint text-muted">{{ hint }}</small>
  </div>
</template>

<script>
import { CURATED_NOTIFICATION_SOUNDS } from '@/utils/taskNotificationDetection';

export default {
  name: 'NotificationSoundPicker',
  props: {
    value: { type: String, required: true },
    label: { type: String, default: 'Notification Sound' },
    hint: { type: String, default: '' },
  },
  data() {
    return { sounds: CURATED_NOTIFICATION_SOUNDS };
  },
  computed: {
    currentLabel() {
      const match = this.sounds.find(s => s.filename === this.value);
      return match ? match.label : 'sound';
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value);
    },
    preview() {
      try {
        const audio = new Audio('/sounds/' + this.value);
        const p = audio.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => { /* autoplay blocked, ignore */ });
        }
      } catch (_) { /* ignore */ }
    },
  },
};
</script>

<style lang="scss" scoped>
.np-sound-picker__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 6px;
}

.np-sound-picker__row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.np-sound-picker__select {
  flex: 1;
  max-width: 320px;
}

.np-sound-picker__preview {
  flex-shrink: 0;
}

.np-sound-picker__hint {
  display: block;
  margin-top: 4px;
  font-size: 11px;
}
</style>
